/**
 * Whether the backend has said the stack is in maintenance.
 *
 * Set once by the first response that carries the backend's maintenance marker and never
 * cleared: the window ends on a reload, which the maintenance page offers.
 */

/** Set by the backend on its maintenance 503, which an overload shed does not carry. */
const MAINTENANCE_HEADER = "x-layer-maintenance";

let isInMaintenance = false;
const listeners = new Set<() => void>();

export const isMaintenanceResponse = (response: Response): boolean =>
  response.status === 503 && response.headers.get(MAINTENANCE_HEADER) === "1";

export const reportMaintenance = (): void => {
  if (isInMaintenance) return;
  isInMaintenance = true;
  listeners.forEach((listener) => listener());
};

export const subscribeToMaintenance = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getIsInMaintenance = (): boolean => isInMaintenance;
